import React from 'react'
import Contact from "../components/Contact/Contact"
import { getInitialData } from "../service/apiFetch";
export const getStaticProps = async () => {
    const initialData = await getInitialData("contact", {
      contentBlock: "Object",
    });
    return {
      props: {
        websiteData: initialData?.websiteData || "",
        data: initialData?.data || "",
        title: initialData?.title || "",
        metaTags: initialData?.metaTags || "",
        error: initialData?.error || "",
      },
    };
  };
  

export default function contact({data,websiteData}) {
  return (
    <div><Contact data={data?.contentBlock?.CONTACT} websitedata={websiteData}/></div>
  )
}
